import { UserType } from "../../views/users/UserTypes";

export interface Task {
    id: number | null;
    uuid?: string;
    created: string | null;
    modified: string | null;
    date: string | null;
    start_datetime: string | null;
    start_time: string | null;
    subject: string;
    checked: boolean;
    checked_at: string | null;
    type: number | null;
    note: string | null;
    assignee: number | null;
    created_by_user?: number | null;
    modified_by_user?: number | null;
    checked_by_user?: number | null;
    organization: number | null;
    person: number | null;
    location: number | null;
    deal: number | null;
    proposal: number | null;
    order: number | null;
    job: number | null;
    invoice: number | null;
    timeline_items?: string[];
    timeline_object_id: number | null;
    timeline_page_id?: string;
    deleted: boolean;
}

export const createNewTask = (uuid: string, defaultAssignee: UserType | null): Task => ({
    id: null,
    uuid: uuid,
    created: null,
    modified: null,
    date: null,
    start_datetime: null,
    start_time: null,
    subject: '',
    checked: false,
    checked_at: null,
    type: null,
    note: null,
    assignee: defaultAssignee ? defaultAssignee.id : null,
    organization: null,
    person: null,
    location: null,
    deal: null,
    proposal: null,
    order: null,
    job: null,
    invoice: null,
    timeline_object_id: null,
    deleted: false
})

export type TaskType = {
    id: number;
    created: string;
    modified: string;
    name: string;
    icon: string;
    ordering: number;
}